export default __webpack_public_path__ + "static/media/4.501c7166.JPG";